import Contact from "../components/Contact";
import Seo from "../components/Seo";

const ContactPage = () => {
  return (
    <>
      <Seo
        title="Contact Saroj Giri | Full Stack Developer, Nepal"
        description="Contact Saroj Giri, an ICT graduate and full-stack developer in Damauli, Nepal. Send a WhatsApp message about a role, a website, or an app."
        path="/contact"
      />
      <Contact page intro="I am an ICT graduate in Damauli, Nepal, and I am open to full-time roles and freelance work. Send a short note and I will reply on WhatsApp." />
    </>
  );
};

export default ContactPage;
